import { combineReducers } from 'redux';
import screenReducer from './screenReducer';
import authReducer from './authReducer';

export default combineReducers({
    screens: screenReducer,
    auth: authReducer,
})

